import React from 'react';
import { string } from '../../localization';
import './CancelButton.scss';

const cancelButton = props => {
  const { clickHandler, buttonLabel } = props;
  let label = '';
  if (buttonLabel) {
    label = buttonLabel;
  } else {
    label = string.CANCEL_TEXT_KEY;
  }
  return (
    <>
      <button type='button' className='cancelButton' onClick={clickHandler}>
        <text className='button-label'>{label}</text>
      </button>
    </>
  );
};

export default cancelButton;
